import './Pagination.scss'
import { FC } from 'react';
import { Link, useLocation } from "react-router-dom";

interface IPagination {
    totalItems: number;
    itemsPerPage: number;
    currentPage: number;
    onPageChange?: (pageNumber: number) => void;
    pageUrl?: string
}

const Pagination: FC<IPagination> = ({
                                         totalItems,
                                         itemsPerPage,
                                         currentPage = 1,
                                         onPageChange = () => {},
                                         pageUrl = ''
                                     }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const location = useLocation();

    const current = Number(currentPage);

    const handlePageChange = (pageNumber: number) => {
        if (pageNumber <= totalPages && pageNumber >= 1) {
            onPageChange(pageNumber);
        }
    };

    const renderPaginationItems = () => {
        const paginationItems = [];
        const range = 2;

        let lastAdded = 0;

        for (let i = 1; i <= totalPages; i++) {
            if (
                i === 1 ||
                (i >= current - range && i <= current + range) ||
                i === totalPages
            ) {

                if (lastAdded > 0 && i - lastAdded > 1) {
                    paginationItems.push(
                        <li key={`ellipsis-${i}`} className="ellipsis" style={{ padding: '0 5px', color: '#BBB7B7', pointerEvents: 'none' }}>
                            <span>...</span>
                        </li>
                    );
                }

                paginationItems.push(
                    <li key={i} className={current === i ? 'active' : ''}>
                        <Link to={`${pageUrl}/page/${i}${location.search}`} onClick={() => handlePageChange(i)}>
                            {i}
                        </Link>
                    </li>,
                );
                lastAdded = i;
            }
        }
        return paginationItems.length > 1 ? paginationItems : [];
    };

    if (totalPages <= 1) return null;

    return (
        <ul className="pagination">
            {renderPaginationItems()}
        </ul>
    );
};

export default Pagination;